import React from 'react';
import { useLocation } from 'react-router-dom';
import { MdHomeFilled, MdSubscriptions, MdAddCircle, MdVideoLibrary, MdPerson } from 'react-icons/md';
import './FooterNav.css';

function FooterNav({ onHome, onSubscriptions, onUpload, onAccount, onLibrary }) {
  const location = useLocation();
  const path = location.pathname || '/';

  return (
    <nav className="footer-nav">
      <button type="button" className={`nav-item ${path === '/' ? 'active' : ''}`} onClick={onHome}>
        <MdHomeFilled className="nav-icon" />
        <span>Accueil</span>
      </button>

      <button
        type="button"
        className={`nav-item ${path.startsWith('/subscriptions') || path.startsWith('/abonnement') ? 'active' : ''}`}
        onClick={onSubscriptions}
      >
        <MdSubscriptions className="nav-icon" />
        <span>Abonnements</span>
      </button>

      <button type="button" className="nav-item nav-upload" onClick={onUpload} aria-label="Creer">
        <MdAddCircle className="nav-upload-icon" />
        <span>Creer</span>
      </button>

      <button
        type="button"
        className={`nav-item ${path.startsWith('/library') || path.startsWith('/bibliotheque') ? 'active' : ''}`}
        onClick={onLibrary}
      >
        <MdVideoLibrary className="nav-icon" />
        <span>Bibliotheque</span>
      </button>

      <button type="button" className={`nav-item ${path.startsWith('/account') || path.startsWith('/vous') ? 'active' : ''}`} onClick={onAccount}>
        <MdPerson className="nav-icon" />
        <span>Vous</span>
      </button>
    </nav>
  );
}

export default FooterNav;
